import { WatchlistType, WatchlistTypeValue, WatchlistFetcher, WatchlistResponse } from '../types/WatchlistTypes';

export const getWatchlistTypes = (favoritesResponse: any): WatchlistTypeValue[] => {
    if (!favoritesResponse) return [WatchlistType.ALL];

    const types: WatchlistTypeValue[] = [];

    if (Object.keys(favoritesResponse.vod_asset_bookmarks || {}).length > 0) {
        types.push(WatchlistType.MOVIES);
    }

    if (Object.keys(favoritesResponse.program_series_bookmarks || {}).length > 0) {
        types.push(WatchlistType.SERIES);
    }

    return types.length ? types : [WatchlistType.ALL];
};

export const createWatchlistFetcher =
    (fetcher: WatchlistFetcher) =>
    (
        type: WatchlistTypeValue = WatchlistType.ALL,
        page = '1',
        per_page = 10,
        image_size = 'medium',
        image_aspect_ratio = '16:9'
    ): Promise<WatchlistResponse> =>
        fetcher({
            page,
            per_page,
            image_size,
            watchlist_type: type,
            image_aspect_ratio,
        }).then((response) => ({
            ...response,
            watchlist_type: type,
        }));
